(function TripSummarySort($, Adzuki)
{
	'use strict';

	const component = {
		emits   : ['updated', 'set-default'],
		inject  : ['getFaIconStyle'],
		template: '#ts-sort',
		props   : {
			sortByKey: {
				type    : String,
				required: false,
				default : 'start_date',
			},
			sortByDirection: {
				type    : String,
				required: false,
				default : 'desc',
			},
			// TS-390: the agent's profile default, so the dropdown can mark it, and
			// whether to offer "Set as my default" -- the Active tab only, which is
			// the only tab the default applies to
			defaultKey: {
				type    : String,
				required: false,
				default : null,
			},
			defaultDirection: {
				type    : String,
				required: false,
				default : null,
			},
			showDefaultControl: {
				type    : Boolean,
				required: false,
				default : false,
			},
		},
		data() {
			return {
				sortOptions: [
					{
						key        : 'title',
						label      : 'Title',
						description: 'Trip Summary title',
					},
					{
						key        : 'client',
						label      : 'Client',
						description: 'Last name of client',
					},
					{
						key  : 'created_date',
						label: 'Created Date',
					},
					{
						key  : 'start_date',
						label: 'Trip Start Date',
					},
					{
						key        : 'component_count',
						label      : 'Component Count',
						description: 'Total number of components',
					},
					{
						key  : 'last_viewed_date',
						label: 'Last Viewed Date',
					},
					{
						key        : 'agent',
						label      : 'Agent',
						description: 'Last name of agent',
					},
				],
			};
		},
		computed: {
			currentIsDefault() {
				return Boolean(this.defaultKey)
					&& this.sortByKey === this.defaultKey
					&& this.sortByDirection === this.defaultDirection;
			},
		},
		methods: {
			activeOption(key, direction) {
				return this.sortByKey === key && this.sortByDirection === direction;
			},
			changeSort(key, direction) {
				if (this.sortByKey === key && this.sortByDirection === direction) {
					return;
				}

				const newSort = {
					key      : key,
					direction: direction,
				};

				this.$emit('updated', newSort);
			},
			// TS-390: the direction the agent's default uses for this key, or null
			defaultDirectionFor(key) {
				return (this.defaultKey === key ? this.defaultDirection : null);
			},
			setDefault() {
				this.$emit('set-default', {
					key      : this.sortByKey,
					direction: this.sortByDirection,
				});
			},
		},
		mounted() {
			this.sortBy = {
				key      : this.sortByKey,
				direction: this.sortByDirection,
			};
		},
	};

	Adzuki.VueComponents.TripSummarySort = component;
}(jQuery, window.Adzuki || {}));
